<script setup>
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/components/ui/input-group";
import { Search } from "lucide-vue-next";
import { ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  onChange: {
    type: Function,
    required: true,
  },
});

const insideModelValue = ref(props.modelValue);

watch(insideModelValue, (newValue) => {
  // Emit the update event when insideModelValue changes
  props.onChange(newValue);
});
</script>

<template>
  <div class="flex align-items-center gap-2 lg:px-16">
    <InputGroup>
      <InputGroupInput placeholder="Search..." v-model="insideModelValue" />
      <InputGroupAddon>
        <Search />
      </InputGroupAddon>
    </InputGroup>
  </div>
</template>
